import {InMemoryCache} from '@apollo/client/cache'
import {ApolloLink, HttpLink, ApolloClient} from '@apollo/client'
import {isClient} from '../../utils'
import getLogLink from '../client/links/log'
import fetch from '../fetch'
import config from 'config'

class ApolloCache {
  constructor() {
    this.clients = {}
  }

  getOptions(ttl) {
    return {
      ssrMode: !isClient(),
      state: isClient() && window.APOLLO_CACHE ? window.APOLLO_CACHE[ttl] : null,
      uri: isClient() ? config.graphqlUri : config.ssGraphqlUri
    }
  }

  scheduleExpiration(ttl) {
    if (!isClient()) {
      setTimeout(() => delete this.clients[ttl], ttl * 60 * 1000) // Ttl in minutes
    }
  }

  extract() {
    const data = {}

    Object.keys(this.clients).forEach(key => {
      data[key] = this.clients[key].extract()
    })

    return data
  }

  getClient(ttl) {
    if (this.clients[ttl]) {
      return this.clients[ttl]
    }

    const options = Object.assign(this.getOptions(ttl)),
      httpLink = new HttpLink({uri: options.uri, credentials: 'same-origin', fetch}),
      cache = new InMemoryCache()

    this.clients[ttl] = new ApolloClient({
      ssrMode: !!options.ssrMode,
      link: ApolloLink.from([
        getLogLink(),
        httpLink
      ]),
      cache: options.state ? cache.restore(options.state) : cache
    })

    this.scheduleExpiration(ttl)

    return this.clients[ttl]
  }
}

export {ApolloCache}

export default ApolloCache
